/**
 * 全站权限配置
 *
 */
import router from './router/router';
import store from '@/store';
import { validatenull } from '@/util/validate';
import { directLogin, queryByStaffId } from '@/api/login';
import { localPlatformKey, defaultPlatform } from '@/const/common';

import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
NProgress.configure({ showSpinner: false });

let jwt = require('jsonwebtoken');
/**
 * 导航守卫，相关内容可以参考:
 * https://router.vuejs.org/zh/guide/advanced/navigation-guards.html
 */
router.beforeEach((to, from, next) => {
  // 缓冲设置
  if (
    to.meta.keepAlive === true &&
    store.state.tags.tagList.some((ele) => {
      return ele.value === to.fullPath;
    })
  ) {
    to.meta.$keepAlive = true;
  } else {
    NProgress.start();
    if (to.meta.keepAlive === true && validatenull(to.meta.$keepAlive)) {
      to.meta.$keepAlive = true;
    } else {
      to.meta.$keepAlive = false;
    }
  }
  if (to.redirectedFrom && to.redirectedFrom.indexOf('redirectDot') > 0) {
    const token = to.query.token;
    const jumpType = to.query.type;
    const sourceId = to.query.sourceId;

    let path = '/wel';
    if (jumpType === 'orderDetail') {
      path = '/dot/order/detail/' + sourceId;
    }
    if (to.query?.staffId) {
      queryByStaffId({
        staffId: to.query?.staffId,
      }).then((res) => {
        const data = res.data?.data;
        login(data?.username, data?.password, path);
      });
    } else {
      //redirectDot?type=orderDetail&sourceId=163871185678a1665008e2907b40c8cf&token=12312
      jwt.verify(token, 'e7yi.com', (error, decode) => {
        // jsonwebtoken第三方库校验Token
        //console.log(decode.data.account,decode.data.password,)
        console.log(decode, error);
        //todo 判断是否失效
        login(decode?.data?.account, decode?.data?.password, path);
      });
    }
  } else if (
    to.redirectedFrom &&
    to.redirectedFrom.indexOf('redirectHidden') > 0
  ) {
    let path = '/wel';
    if (to.query.jumpType === 'orderDetail') {
      path = '/dot/order/detail/' + to.query.sourceId;
    }
    login(to.query.account, to.query.password, path);
  } else {
    extracted();
  }

  function login(account, password, path) {
    directLogin(account, password).then((response) => {
      const data = response?.data;
      store.commit('SET_ACCESS_TOKEN', data.access_token);
      store.commit('SET_REFRESH_TOKEN', data.refresh_token);
      store.commit('SET_EXPIRES_IN', data.expires_in);
      store.commit('CLEAR_LOCK');
      extracted(path);
    });
  }

  function extracted(path) {
    const meta = to.meta || {};
    if (store.getters.access_token) {
      if (to.path === '/login') {
        const cachePlatform = sessionStorage.getItem(localPlatformKey);
        if (cachePlatform != 'dot' && cachePlatform != 'system') {
          window.location.href = '/m_op';
        } else {
          next({ path: '/' });
        }
      } else {
        // NOTE: 当用户角色不存在时，会存在无限请求用户信息接口的问题
        if (
          store.getters.roles.length === 0 ||
          !Object.keys(store.getters.permissions).length
        ) {
          store
            .dispatch('GetUserInfo')
            .then(() => {
              if (path) {
                next({ path: path });
              } else {
                next();
              }
            })
            .catch(() => {
              store.dispatch('FedLogOut').then(() => {
                next({ path: '/login' });
              });
            });
        } else {
          const value = to.query.src || to.fullPath;
          const label =
            to.query.name || to.name || to.query.specific + '的任务详情';
          if (
            meta.isTab !== false &&
            !validatenull(value) &&
            !validatenull(label)
          ) {
            store.commit('ADD_TAG', {
              label: label,
              value: value,
              params: to.params,
              query: to.query,
              group: router.$avueRouter.group || [],
            });
          }
          if (path) {
            next({ path: path });
          } else {
            next();
          }
        }
      }
    } else {
      if (meta.isAuth === false) {
        next();
      } else {
        next('/login');
      }
    }
  }
});

router.afterEach(() => {
  NProgress.done();
  const title = store.getters.tag.label;
  router.$avueRouter.setTitle(title);
});
